import React from "react";
import { Link } from "react-router-dom";
import { t } from "../../i18n";
import { FaPhone, FaCalendarCheck } from "react-icons/fa";
import "./CTABanner.css";

export default function CTABanner({ client, locale = "en" }) {
  return (
    <section className="cta-banner">
      <div className="container">
        <div className="cta-content">
          <h2>{t("cta.schedule", locale)}</h2>
          <p>Free consultation • Same-day appointments available • Most insurance accepted</p>
          <div className="cta-actions">
            <Link to="/request-appt" className="cta-btn-primary"><FaCalendarCheck /> Book Appointment</Link>
            <a href={`tel:${client.phone}`} className="cta-btn-secondary"><FaPhone /> {client.phone}</a>
          </div>
        </div>
      </div>
    </section>
  );
}
